<template>
    <div class="big_box">

        <div class="show show_fei" v-if="type == 'type_init'">
            <img :src="shows_card_list[number]" style="width:100%" loop="infinite"/>
        </div>
        <div class="show show_fei" v-if="type == 'type_01'">
            <img :src="shows_list[number]" style="width:100%" loop="infinite"/>
        </div>


        <div class="content_text">

            <div class="show" v-show="type == 'type_02'">
                <div v-for="item,key in role_list" v-show="key==index">
                    <img :src="role[item]" alt style="width:100%"/>
                </div>
            </div>

            <div class="show" v-show="type == 'type_03'">
                <div class="img_38 close" @click="close"></div>
                <div class="img_62">
                    <div style="height: 0.5rem"></div>
                    <div class="swiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="item,key in role_list">
                                <img :src="s_role[item]" style="width: 100%"/>
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                    <div class="text_congratulations">
                        五星特工{{ role_list.map(i => lotter_conf_name[i]).join('、') }}现在加入您的同行舱候选位
                    </div>
                    <div class="button">
                        <div class="img_44 cursor" @click="type_04"></div>
                        <div class="img_43 cursor" @click="shave_page"></div>
                    </div>
                </div>
            </div>
            <div class="show" v-show="type == 'type_04'">
                <div class="img_38 close" @click="close"></div>
                <div class="img_62">
                    <div style="height: 0.5rem"></div>
                    <div class="img_215 center">
                        <div :class="'sizebox size_'+goods_list.length">
                            <div :class="'small_ico ico_'+item" v-for="item,key in goods_list" :key="key">
                                <div class="text" v-text="lotter_conf_name[item]"></div>
                            </div>
                        </div>
                    </div>
                    <div class="text_congratulations">
                        以上卡带打印箱奖励现已加入您的同行舱候选位
                    </div>
                    <div class="button">
                        <div class="img_44 cursor" @click="type_05"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var shows_list = [
    require('../../../img/lottery/show/1.jpg'),
    require('../../../img/lottery/show/2.jpg'),
    require('../../../img/lottery/show/3.jpg'),
    require('../../../img/lottery/show/4.jpg'),
    require('../../../img/lottery/show/5.jpg'),
    require('../../../img/lottery/show/6.jpg'),
    require('../../../img/lottery/show/7.jpg'),
    require('../../../img/lottery/show/8.jpg'),
    require('../../../img/lottery/show/9.jpg'),
    require('../../../img/lottery/show/10.jpg'),
    require('../../../img/lottery/show/11.jpg'),
    require('../../../img/lottery/show/12.jpg'),
    require('../../../img/lottery/show/13.jpg'),
    require('../../../img/lottery/show/14.jpg'),
    require('../../../img/lottery/show/15.jpg'),
    require('../../../img/lottery/show/16.jpg'),
    require('../../../img/lottery/show/17.jpg'),
    require('../../../img/lottery/show/18.jpg'),
    require('../../../img/lottery/show/19.jpg'),
    require('../../../img/lottery/show/20.jpg'),
    require('../../../img/lottery/show/21.jpg'),
    require('../../../img/lottery/show/22.jpg'),
    require('../../../img/lottery/show/23.jpg'),
    require('../../../img/lottery/show/24.jpg'),
    require('../../../img/lottery/show/25.jpg'),
    require('../../../img/lottery/show/26.jpg'),
    require('../../../img/lottery/show/27.jpg'),
    require('../../../img/lottery/show/28.jpg'),
    require('../../../img/lottery/show/29.jpg'),
    require('../../../img/lottery/show/30.jpg'),
    require('../../../img/lottery/show/31.jpg'),
    require('../../../img/lottery/show/32.jpg'),
    require('../../../img/lottery/show/33.jpg'),
    require('../../../img/lottery/show/34.jpg'),
    require('../../../img/lottery/show/35.jpg'),
    require('../../../img/lottery/show/36.jpg'),
    require('../../../img/lottery/show/37.jpg'),
    require('../../../img/lottery/show/38.jpg'),
    require('../../../img/lottery/show/39.jpg'),
    require('../../../img/lottery/show/40.jpg'),
    require('../../../img/lottery/show/41.jpg'),
    require('../../../img/lottery/show/42.jpg'),
    require('../../../img/lottery/show/43.jpg'),
    require('../../../img/lottery/show/44.jpg'),
    require('../../../img/lottery/show/45.jpg'),
    require('../../../img/lottery/show/46.jpg'),
    require('../../../img/lottery/show/47.jpg'),
    require('../../../img/lottery/show/48.jpg'),
    require('../../../img/lottery/show/49.jpg'),
    require('../../../img/lottery/show/50.jpg'),
    require('../../../img/lottery/show/51.jpg'),
    require('../../../img/lottery/show/52.jpg'),
    require('../../../img/lottery/show/53.jpg'),
    require('../../../img/lottery/show/54.jpg'),
    require('../../../img/lottery/show/55.jpg'),
    require('../../../img/lottery/show/56.jpg'),
    require('../../../img/lottery/show/57.jpg'),
    require('../../../img/lottery/show/58.jpg'),
    require('../../../img/lottery/show/59.jpg'),
    require('../../../img/lottery/show/60.jpg'),
    require('../../../img/lottery/show/61.jpg'),
    require('../../../img/lottery/show/62.jpg'),
    require('../../../img/lottery/show/63.jpg'),
    require('../../../img/lottery/show/64.jpg'),
    require('../../../img/lottery/show/65.jpg'),
    require('../../../img/lottery/show/66.jpg'),
    require('../../../img/lottery/show/67.jpg'),
    require('../../../img/lottery/show/68.jpg'),
    require('../../../img/lottery/show/69.jpg'),
    require('../../../img/lottery/show/70.jpg'),
    require('../../../img/lottery/show/71.jpg'),
    require('../../../img/lottery/show/72.jpg'),
    require('../../../img/lottery/show/73.jpg'),
    require('../../../img/lottery/show/74.jpg'),
    require('../../../img/lottery/show/75.jpg'),
    require('../../../img/lottery/show/76.jpg'),
    require('../../../img/lottery/show/77.jpg'),
]

var shows_card_list = [
    require('../../../img/lottery/card_show/1.png'),
    require('../../../img/lottery/card_show/2.png'),
    require('../../../img/lottery/card_show/3.png'),
    require('../../../img/lottery/card_show/4.png'),
    require('../../../img/lottery/card_show/5.png'),
    require('../../../img/lottery/card_show/6.png'),
    require('../../../img/lottery/card_show/7.png'),
    require('../../../img/lottery/card_show/8.png'),
    require('../../../img/lottery/card_show/9.png'),
    require('../../../img/lottery/card_show/10.png'),
    require('../../../img/lottery/card_show/11.png'),
    require('../../../img/lottery/card_show/12.png'),
    require('../../../img/lottery/card_show/13.png'),
    require('../../../img/lottery/card_show/14.png'),
    require('../../../img/lottery/card_show/15.png'),
    require('../../../img/lottery/card_show/16.png'),
    require('../../../img/lottery/card_show/17.png'),
    require('../../../img/lottery/card_show/18.png'),
    require('../../../img/lottery/card_show/19.png'),
    require('../../../img/lottery/card_show/20.png'),
    require('../../../img/lottery/card_show/21.png'),
    require('../../../img/lottery/card_show/22.png'),
    require('../../../img/lottery/card_show/23.png'),
    require('../../../img/lottery/card_show/24.png'),
    require('../../../img/lottery/card_show/25.png'),
    require('../../../img/lottery/card_show/26.png'),
    require('../../../img/lottery/card_show/27.png'),
    require('../../../img/lottery/card_show/28.png'),
    require('../../../img/lottery/card_show/29.png'),

    require('../../../img/lottery/card_show/30.png'),
    require('../../../img/lottery/card_show/31.png'),
    require('../../../img/lottery/card_show/32.png'),
    require('../../../img/lottery/card_show/33.png'),
    require('../../../img/lottery/card_show/34.png'),
    require('../../../img/lottery/card_show/35.png'),
    require('../../../img/lottery/card_show/36.png'),
    require('../../../img/lottery/card_show/37.png'),
    require('../../../img/lottery/card_show/38.png'),
    require('../../../img/lottery/card_show/39.png'),

    require('../../../img/lottery/card_show/40.png'),
    require('../../../img/lottery/card_show/41.png'),
    require('../../../img/lottery/card_show/42.png'),
    require('../../../img/lottery/card_show/43.png'),
    require('../../../img/lottery/card_show/44.png'),
    require('../../../img/lottery/card_show/45.png'),
    require('../../../img/lottery/card_show/46.png'),
    require('../../../img/lottery/card_show/47.png'),
    require('../../../img/lottery/card_show/48.png'),
    require('../../../img/lottery/card_show/49.png'),

    require('../../../img/lottery/card_show/50.png'),
    require('../../../img/lottery/card_show/51.png'),
    require('../../../img/lottery/card_show/52.png'),
    require('../../../img/lottery/card_show/53.png'),
    require('../../../img/lottery/card_show/54.png'),
    require('../../../img/lottery/card_show/55.png'),
    require('../../../img/lottery/card_show/56.png'),
    require('../../../img/lottery/card_show/57.png'),
    require('../../../img/lottery/card_show/58.png'),
    require('../../../img/lottery/card_show/59.png'),
]
var role = {
    0: require('../../../img/lottery/0.png'),
    1: require('../../../img/lottery/1.png'),
    2: require('../../../img/lottery/2.png'),
    3: require('../../../img/lottery/3.png'),
    4: require('../../../img/lottery/4.png'),
    5: require('../../../img/lottery/5.png'),
    6: require('../../../img/lottery/6.png'),
}
var s_role = {
    0: require('../../../img/lottery/s_0.png'),
    1: require('../../../img/lottery/s_1.png'),
    2: require('../../../img/lottery/s_2.png'),
    3: require('../../../img/lottery/s_3.png'),
    4: require('../../../img/lottery/s_4.png'),
    5: require('../../../img/lottery/s_5.png'),
    6: require('../../../img/lottery/s_6.png'),
}

var show_role = {
    0: require('../../../img/lottery/show_0.png'),
    1: require('../../../img/lottery/show_1.png'),
    2: require('../../../img/lottery/show_2.png'),
    3: require('../../../img/lottery/show_3.png'),
    4: require('../../../img/lottery/show_4.png'),
    5: require('../../../img/lottery/show_5.png'),
    6: require('../../../img/lottery/show_6.png'),
}

module.exports = {
    props: ['data'],
    data() {
        return {
            role_list : [],
            index     : 0,
            role      : role,
            time      : null,
            type      : null,
            s_role    : s_role,
            show_role : show_role,
            swiper    : null,
            goods_list: [],
            number    : 0,
            shows_card_list,
            shows_list,
        }
    },
    created() {
        // var arr = {
        //     item_id: "11", item_name: "《毛球怪幸存者》随机部件"
        // }
        this.init(this.data.items)
    },
    methods: {
        init(arr) {
            this.arr = arr
            var role_list = arr.filter(i => i < 7)
            this.goods_list = arr.filter(i => i >= 7).sort()
            this.role_list = role_list
            this.index = 0
            console.log('role_list', role_list)
            role_list.length && this.load_img(role_list)
            this.type = 'type_init'
            this.show_gif(this.shows_card_list, () => this.role_list.length ? this.type_01() : this.type_04())
        },
        show_gif(gif_list, callback) {
            this.number = 0
            var time = setInterval(() => {
                this.number++
                if (this.number >= gif_list.length) {
                    clearInterval(time)
                    callback()
                }
            }, 30)
        },
        load_img(arr) {
            arr.forEach(i => {
                var img = new Image()
                img.src = show_role[i]


                var img2 = new Image()
                img2.src = s_role[i]

                var img3 = new Image()
                img3.src = role[i]
            })
        },
        close() {
            this.$emit('close')
        },
        type_01() {
            this.type = 'type_01'
            this.show_gif(this.shows_list, () => this.type_02())
        },
        type_02() {
            this.type = 'type_02'
            this.time = setInterval(() => {
                if (++this.index >= this.role_list.length) {
                    this.time && clearInterval(this.time)
                    this.time = null
                    this.type_03()
                }
            }, 800)
        },
        type_03() {
            this.type = 'type_03'
            this.$nextTick(() => {
                setTimeout(() => {
                    this.swiper = new Swiper('.swiper', {
                        autoplay    : false,//可选选项，自动滑动
                        initialSlide: this.role_list.length,
                        pagination  : {
                            el: '.swiper-pagination',
                        },
                    })
                }, 10)
            })
        },
        type_04() {
            this.goods_list.length ? this.type = 'type_04' : this.type_05()
        },
        type_05() {
            this.data.that.update_alter(null, null, this.data.items.map(i => i))
        },
        shave_page() {
            var number = this.swiper && this.swiper.realIndex
            var item_id = this.role_list[number]
            this.$alter_err.show_box('shave_page', {role_img: this.show_role[item_id],that:this.data.that})
        },
    },
    beforeDestrooy() {
        this.time && clearInterval(this.time)
        this.time = null
    },
}
</script>

<style scoped>
.content_text {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    font-size: 0.36rem;
    color: #000000;
}

.big_box.big_box.big_box.big_box {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    overflow-y: inherit;
}


.close {
    cursor: pointer;
    position: absolute;
    right: -.3rem;
    top: -0.1rem;
    z-index: 22;
}

.swiper {
    width: 5.73rem;
    height: 4.05rem;
    margin: auto;
    overflow: hidden;
}

.text_congratulations {
    margin: 0.35rem auto;
    margin-bottom: 0.2rem;
    text-align: center;
    font-size: .18rem;
    width: 93%;
}

.swiper .swiper-pagination.swiper-pagination.swiper-pagination {
    bottom: 1.4rem;
}

.swiper >>> .swiper-pagination-bullet-active {
    opacity: 1;
    background: #FF7009;
}

.swiper .swiper-pagination-bullet {
    width: 0.15rem;
    height: 0.15rem;
    margin: 0rem 0.1rem;
}

.show_fei {
    position: absolute;
    left: 50%;
    top: 50%;
    /*margin-top: -0.1rem;*/
    transform: translate(-50%, -50%);
    width: 7.5rem;
    height: 100%;
    height: 100vh;
    background: #000000;
}

.show_fei img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.button.button.button {
    margin-top: 0.1rem;
}

.center {
    margin: auto;
    position: relative;
}

.small_ico {
    position: relative;
    width: 1.3rem;
    height: 1.3rem;
    display: inline-block;
    margin: 0.1rem 0.2rem
}

.sizebox {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-algin: center;
}

.size_5 {
    width: 100%;
}

.size_4 {
    width: 80%;
}

.size_3 {
    width: 70%
}

.size_2 {
    width: 70%
}
.small_ico .text{
    position: absolute;
    width: 1.7rem;
    left: 50%;
    margin-left: -0.85rem;
    bottom: -0.18rem;
    text-align: center;
    font-size: 0.18rem;
    color: #fdf7e5;
}
</style>